const europeanRecipes = [
  // ============================================================
  // ITALIAN (6)
  // ============================================================
  {
    title: 'Margherita Pizza',
    description:
      'The queen of Neapolitan pizzas, topped with San Marzano tomatoes, fresh mozzarella, and fragrant basil on a blistered, chewy crust. Simple ingredients elevated to perfection.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/margherita-pizza.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/margherita-pizza-prep.jpg', caption: 'Stretching the dough', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 30,
    cookTime: 12,
    totalTime: 42,
    difficulty: 'medium',
    spiceLevel: 0,

    cuisine: 'Italian',
    region: 'Europe',
    country: 'Italy',

    categories: ['Dinner', 'Family Meals'],
    tags: ['vegetarian', 'family-friendly', 'date-night', 'baking'],
    ageGroups: ['kid', 'teen', 'adult'],
    audience: 'family',

    nutrition: {
      calories: 520,
      protein: 22,
      carbs: 62,
      fat: 20,
      fiber: 3,
      sugar: 5,
      sodium: 890,
      iron: 3.8,
    },

    ingredients: [
      { qty: 3.5, unit: 'cups', item: 'bread flour', group: 'Dough' },
      { qty: 1, unit: 'tsp', item: 'instant yeast', group: 'Dough' },
      { qty: 1.5, unit: 'tsp', item: 'salt', group: 'Dough' },
      { qty: 1.25, unit: 'cups', item: 'warm water', group: 'Dough' },
      { qty: 2, unit: 'tbsp', item: 'olive oil', group: 'Dough' },
      { qty: 1, unit: 'cup', item: 'San Marzano tomatoes, crushed by hand', group: 'Topping' },
      { qty: 8, unit: 'oz', item: 'fresh mozzarella, sliced', group: 'Topping' },
      { qty: 0.25, unit: 'cup', item: 'fresh basil leaves', group: 'Topping' },
      { qty: 1, unit: 'tbsp', item: 'extra virgin olive oil', group: 'Topping' },
      { qty: 0.5, unit: 'tsp', item: 'flaky sea salt', group: 'Topping' },
    ],
    steps: [
      { order: 1, instruction: 'Combine flour, yeast, and salt in a large bowl. Add warm water and olive oil, then mix until a shaggy dough forms. Knead on a floured surface for 8-10 minutes until smooth and elastic.', timerMinutes: 10 },
      { order: 2, instruction: 'Place the dough in a lightly oiled bowl, cover with plastic wrap, and let rise at room temperature until doubled in size, about 1.5 hours.', timerMinutes: 90 },
      { order: 3, instruction: 'Preheat oven to 500 degrees F with a baking stone or inverted sheet pan on the middle rack for at least 30 minutes.', timerMinutes: 30 },
      { order: 4, instruction: 'Divide dough into 4 equal portions. On a floured surface, stretch each portion into a thin 10-inch round, leaving the edges slightly thicker for the crust.', timerMinutes: null },
      { order: 5, instruction: 'Spread a thin layer of crushed tomatoes over the dough, leaving a half-inch border. Distribute mozzarella slices evenly on top.', timerMinutes: null },
      { order: 6, instruction: 'Slide the pizza onto the hot stone and bake until the crust is deeply golden and the cheese is bubbling with charred spots, about 10-12 minutes.', timerMinutes: 12 },
      { order: 7, instruction: 'Remove from oven, scatter fresh basil leaves over the top, drizzle with extra virgin olive oil, and sprinkle with flaky sea salt. Slice and serve immediately.', timerMinutes: null },
    ],
    notes: 'For a crispier crust, let the dough cold-ferment in the refrigerator for 24-72 hours. If you have a pizza steel, it will give even better results than a stone.',

    communityRating: 4.8,
    communityRatingCount: 412,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Risotto alla Milanese',
    description:
      'A luxurious saffron-infused risotto from Milan, with each grain of Arborio rice coated in a velvety, golden sauce finished with butter and Parmesan. The ultimate Italian comfort food.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/risotto-alla-milanese.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/risotto-alla-milanese-prep.jpg', caption: 'Toasting the rice', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 10,
    cookTime: 30,
    totalTime: 40,
    difficulty: 'medium',
    spiceLevel: 0,

    cuisine: 'Italian',
    region: 'Europe',
    country: 'Italy',

    categories: ['Dinner', 'Sides'],
    tags: ['vegetarian', 'gluten-free', 'comfort-food', 'date-night'],
    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 480,
      protein: 14,
      carbs: 58,
      fat: 20,
      fiber: 1,
      sugar: 2,
      sodium: 720,
      iron: 2.4,
    },

    ingredients: [
      { qty: 1.5, unit: 'cups', item: 'Arborio rice', group: 'Risotto' },
      { qty: 5, unit: 'cups', item: 'chicken or vegetable broth, warmed', group: 'Risotto' },
      { qty: 0.5, unit: 'cup', item: 'dry white wine', group: 'Risotto' },
      { qty: 1, unit: 'pinch', item: 'saffron threads (about 1/4 tsp)', group: 'Risotto' },
      { qty: 1, unit: '', item: 'medium yellow onion, finely diced', group: 'Risotto' },
      { qty: 3, unit: 'tbsp', item: 'unsalted butter, divided', group: 'Risotto' },
      { qty: 2, unit: 'tbsp', item: 'olive oil', group: 'Risotto' },
      { qty: 0.75, unit: 'cup', item: 'Parmigiano-Reggiano, finely grated', group: 'Risotto' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Risotto' },
      { qty: 0.5, unit: 'tsp', item: 'white pepper', group: 'Risotto' },
    ],
    steps: [
      { order: 1, instruction: 'Steep the saffron threads in 1/2 cup of the warm broth and set aside for at least 5 minutes to bloom.', timerMinutes: 5 },
      { order: 2, instruction: 'Heat olive oil and 1 tablespoon of butter in a large, heavy-bottomed pan over medium heat. Add the diced onion and cook until soft and translucent, about 4 minutes. Do not brown.', timerMinutes: 4 },
      { order: 3, instruction: 'Add the Arborio rice and stir constantly for 2 minutes until the grains are toasted and slightly translucent at the edges.', timerMinutes: 2 },
      { order: 4, instruction: 'Pour in the white wine and stir until it is fully absorbed.', timerMinutes: 2 },
      { order: 5, instruction: 'Begin adding the warm broth one ladleful at a time, stirring frequently and waiting until each addition is nearly absorbed before adding the next. After the third addition, stir in the saffron-infused broth. Continue until the rice is creamy and al dente, about 18-20 minutes total.', timerMinutes: 18 },
      { order: 6, instruction: 'Remove from heat. Stir in the remaining 2 tablespoons of butter and the Parmesan until the risotto is glossy and flows like lava. Season with salt and white pepper.', timerMinutes: null },
      { order: 7, instruction: 'Let rest for 1 minute, then serve immediately in warmed bowls with extra Parmesan on top.', timerMinutes: 1 },
    ],
    notes: 'Use real saffron threads, not powder. The key to great risotto is constant stirring and keeping the broth warm so you do not shock the rice.',

    communityRating: 4.6,
    communityRatingCount: 287,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Chicken Parmigiana',
    description:
      'Crispy breaded chicken cutlets smothered in rich marinara and melted mozzarella, baked until bubbly and golden. A beloved Italian-American classic that never disappoints.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/chicken-parmigiana.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/chicken-parmigiana-prep.jpg', caption: 'Breading the chicken', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 25,
    cookTime: 30,
    totalTime: 55,
    difficulty: 'medium',
    spiceLevel: 0,

    cuisine: 'Italian',
    region: 'Europe',
    country: 'Italy',

    categories: ['Dinner', 'Family Meals'],
    tags: ['high-protein', 'family-friendly', 'comfort-food', 'weeknight-dinner'],
    ageGroups: ['kid', 'teen', 'adult'],
    audience: 'family',

    nutrition: {
      calories: 620,
      protein: 48,
      carbs: 34,
      fat: 32,
      fiber: 3,
      sugar: 7,
      sodium: 1050,
      iron: 3.0,
    },

    ingredients: [
      { qty: 4, unit: '', item: 'boneless skinless chicken breasts (about 6 oz each)', group: 'Chicken' },
      { qty: 1, unit: 'cup', item: 'all-purpose flour', group: 'Breading' },
      { qty: 3, unit: '', item: 'large eggs, beaten', group: 'Breading' },
      { qty: 1.5, unit: 'cups', item: 'Italian-style breadcrumbs', group: 'Breading' },
      { qty: 0.5, unit: 'cup', item: 'grated Parmesan cheese', group: 'Breading' },
      { qty: 1, unit: 'tsp', item: 'garlic powder', group: 'Breading' },
      { qty: 0.5, unit: 'cup', item: 'vegetable oil, for frying', group: 'Chicken' },
      { qty: 2, unit: 'cups', item: 'marinara sauce', group: 'Topping' },
      { qty: 8, unit: 'oz', item: 'mozzarella cheese, shredded', group: 'Topping' },
      { qty: 0.25, unit: 'cup', item: 'fresh basil, for garnish', group: 'Topping' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Breading' },
      { qty: 0.5, unit: 'tsp', item: 'black pepper', group: 'Breading' },
    ],
    steps: [
      { order: 1, instruction: 'Preheat oven to 425 degrees F. Place chicken breasts between two sheets of plastic wrap and pound to an even 1/2-inch thickness with a meat mallet.', timerMinutes: null },
      { order: 2, instruction: 'Set up a breading station: flour seasoned with salt and pepper in one shallow dish, beaten eggs in the second, and breadcrumbs mixed with Parmesan and garlic powder in the third. Dredge each cutlet in flour, dip in egg, then press firmly into the breadcrumb mixture on both sides.', timerMinutes: null },
      { order: 3, instruction: 'Heat vegetable oil in a large oven-safe skillet over medium-high heat. Pan-fry the chicken cutlets until golden brown on each side, about 3 minutes per side. Work in batches to avoid crowding.', timerMinutes: 6 },
      { order: 4, instruction: 'Transfer all cutlets to a baking sheet. Spoon marinara sauce over each cutlet and top with shredded mozzarella.', timerMinutes: null },
      { order: 5, instruction: 'Bake in the oven until the cheese is melted and bubbly and the chicken reaches an internal temperature of 165 degrees F, about 15 minutes.', timerMinutes: 15 },
      { order: 6, instruction: 'Optionally broil for 1-2 minutes to get a golden, caramelized cheese top. Watch carefully to prevent burning.', timerMinutes: 2 },
      { order: 7, instruction: 'Garnish with fresh basil and serve with pasta or a simple green salad.', timerMinutes: null },
    ],
    notes: 'Pounding the chicken to an even thickness ensures it cooks evenly. For a lighter version, bake the breaded cutlets on a wire rack instead of frying.',

    communityRating: 4.7,
    communityRatingCount: 380,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Cacio e Pepe',
    description:
      'Rome\'s legendary three-ingredient pasta, where sharp Pecorino Romano and cracked black pepper transform into a silky, intensely savory sauce that clings to every strand of tonnarelli.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/cacio-e-pepe.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/cacio-e-pepe-prep.jpg', caption: 'Toasting black pepper', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 5,
    cookTime: 15,
    totalTime: 20,
    difficulty: 'medium',
    spiceLevel: 1,

    cuisine: 'Italian',
    region: 'Europe',
    country: 'Italy',

    categories: ['Dinner'],
    tags: ['vegetarian', 'under-30-min', 'weeknight-dinner', '5-ingredients-or-less', 'budget-friendly'],
    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 490,
      protein: 20,
      carbs: 56,
      fat: 21,
      fiber: 2,
      sugar: 2,
      sodium: 780,
      iron: 2.6,
    },

    ingredients: [
      { qty: 1, unit: 'lb', item: 'spaghetti or tonnarelli', group: 'Pasta' },
      { qty: 2, unit: 'cups', item: 'Pecorino Romano, finely grated', group: 'Sauce' },
      { qty: 1.5, unit: 'tbsp', item: 'whole black peppercorns, freshly cracked', group: 'Sauce' },
      { qty: 1, unit: 'tbsp', item: 'salt (for pasta water)', group: 'Pasta' },
    ],
    steps: [
      { order: 1, instruction: 'Bring a large pot of water to a boil. Add salt. Note: use less water than usual (about 4 quarts) so the starchy pasta water is more concentrated.', timerMinutes: null },
      { order: 2, instruction: 'While waiting, coarsely crack the peppercorns using a mortar and pestle or the bottom of a heavy pan. Toast them in a large, dry skillet over medium heat for 2 minutes until fragrant, tossing frequently.', timerMinutes: 2 },
      { order: 3, instruction: 'Add 1 cup of starchy pasta water to the skillet with the pepper and simmer to reduce slightly while the pasta cooks.', timerMinutes: null },
      { order: 4, instruction: 'Cook the pasta until 1 minute shy of al dente. Reserve 2 cups of pasta water before draining.', timerMinutes: null },
      { order: 5, instruction: 'Remove the skillet from heat. Toss the drained pasta into the skillet with the pepper water. Gradually add the Pecorino a handful at a time, tossing vigorously and adding splashes of pasta water until a creamy, emulsified sauce forms that coats the strands.', timerMinutes: null },
      { order: 6, instruction: 'Serve immediately in warmed bowls, topped with extra Pecorino and a final crack of black pepper.', timerMinutes: null },
    ],
    notes: 'The biggest mistake is adding the cheese to a pan that is too hot, which causes it to clump. Always remove from heat before incorporating the Pecorino. Use real Pecorino Romano, not a domestic substitute.',

    communityRating: 4.5,
    communityRatingCount: 315,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Minestrone Soup',
    description:
      'A hearty, rustic Italian vegetable soup brimming with seasonal vegetables, cannellini beans, and small pasta in a savory tomato broth. Every spoonful is nourishing and deeply satisfying.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/minestrone-soup.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/minestrone-soup-prep.jpg', caption: 'Diced vegetables ready for the pot', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 6,
    prepTime: 20,
    cookTime: 40,
    totalTime: 60,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'Italian',
    region: 'Europe',
    country: 'Italy',

    categories: ['Dinner', 'Soups & Stews', 'Family Meals'],
    tags: ['vegetarian', 'vegan', 'high-fiber', 'one-pot', 'meal-prep', 'freezer-friendly', 'budget-friendly', 'comfort-food'],
    ageGroups: ['toddler', 'kid', 'teen', 'adult'],
    audience: 'family',

    nutrition: {
      calories: 260,
      protein: 11,
      carbs: 42,
      fat: 6,
      fiber: 9,
      sugar: 8,
      sodium: 740,
      iron: 3.5,
    },

    ingredients: [
      { qty: 2, unit: 'tbsp', item: 'olive oil', group: 'Soup' },
      { qty: 1, unit: '', item: 'large yellow onion, diced', group: 'Soup' },
      { qty: 3, unit: '', item: 'cloves garlic, minced', group: 'Soup' },
      { qty: 2, unit: '', item: 'celery stalks, diced', group: 'Soup' },
      { qty: 2, unit: '', item: 'medium carrots, peeled and diced', group: 'Soup' },
      { qty: 1, unit: '', item: 'medium zucchini, diced', group: 'Soup' },
      { qty: 1, unit: 'cup', item: 'green beans, trimmed and cut into 1-inch pieces', group: 'Soup' },
      { qty: 1, unit: 'can (14.5 oz)', item: 'diced tomatoes', group: 'Soup' },
      { qty: 1, unit: 'can (15 oz)', item: 'cannellini beans, drained and rinsed', group: 'Soup' },
      { qty: 6, unit: 'cups', item: 'vegetable broth', group: 'Soup' },
      { qty: 1, unit: 'cup', item: 'small pasta (ditalini or elbow)', group: 'Soup' },
      { qty: 2, unit: 'cups', item: 'fresh spinach', group: 'Soup' },
      { qty: 1, unit: 'tsp', item: 'dried oregano', group: 'Soup' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Soup' },
      { qty: 0.5, unit: 'tsp', item: 'black pepper', group: 'Soup' },
      { qty: 1, unit: '', item: 'Parmesan rind (optional)', group: 'Soup' },
    ],
    steps: [
      { order: 1, instruction: 'Heat olive oil in a large Dutch oven or soup pot over medium heat. Add onion, celery, and carrots. Cook, stirring occasionally, until softened, about 6 minutes.', timerMinutes: 6 },
      { order: 2, instruction: 'Add garlic and oregano, cooking for 30 seconds until fragrant. Stir in the diced tomatoes with their juices and cook for 2 minutes.', timerMinutes: 2 },
      { order: 3, instruction: 'Pour in the vegetable broth. Add the zucchini, green beans, cannellini beans, and Parmesan rind if using. Bring to a boil, then reduce to a gentle simmer.', timerMinutes: null },
      { order: 4, instruction: 'Simmer uncovered for 15 minutes until the vegetables are just tender.', timerMinutes: 15 },
      { order: 5, instruction: 'Add the pasta and cook for another 10 minutes or until the pasta is al dente, stirring occasionally to prevent sticking.', timerMinutes: 10 },
      { order: 6, instruction: 'Stir in the spinach and let it wilt, about 1 minute. Season with salt and pepper. Remove the Parmesan rind.', timerMinutes: 1 },
      { order: 7, instruction: 'Ladle into bowls and serve with crusty bread and a drizzle of good olive oil.', timerMinutes: null },
    ],
    notes: 'This soup thickens as it sits. Add extra broth when reheating leftovers. Omit the Parmesan rind to keep it fully vegan. Swap vegetables based on what you have available.',

    communityRating: 4.4,
    communityRatingCount: 198,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Tiramisu',
    description:
      'The quintessential Italian dessert with layers of espresso-soaked ladyfingers and impossibly light mascarpone cream, dusted with cocoa. Make it a day ahead for the most luscious texture.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/tiramisu.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/tiramisu-prep.jpg', caption: 'Dipping ladyfingers in espresso', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 8,
    prepTime: 30,
    cookTime: 0,
    totalTime: 30,
    difficulty: 'medium',
    spiceLevel: 0,

    cuisine: 'Italian',
    region: 'Europe',
    country: 'Italy',

    categories: ['Dessert'],
    tags: ['no-cook', 'make-ahead', 'date-night', 'celebration', 'party'],
    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 380,
      protein: 9,
      carbs: 36,
      fat: 22,
      fiber: 0,
      sugar: 24,
      sodium: 120,
      iron: 1.2,
    },

    ingredients: [
      { qty: 6, unit: '', item: 'large egg yolks', group: 'Cream' },
      { qty: 0.75, unit: 'cup', item: 'granulated sugar', group: 'Cream' },
      { qty: 16, unit: 'oz', item: 'mascarpone cheese, at room temperature', group: 'Cream' },
      { qty: 1.5, unit: 'cups', item: 'heavy cream', group: 'Cream' },
      { qty: 1, unit: 'tsp', item: 'vanilla extract', group: 'Cream' },
      { qty: 2, unit: 'cups', item: 'strong brewed espresso, cooled', group: 'Assembly' },
      { qty: 3, unit: 'tbsp', item: 'Marsala wine or dark rum', group: 'Assembly' },
      { qty: 36, unit: '', item: 'Italian ladyfinger cookies (Savoiardi)', group: 'Assembly' },
      { qty: 3, unit: 'tbsp', item: 'unsweetened cocoa powder, for dusting', group: 'Assembly' },
    ],
    steps: [
      { order: 1, instruction: 'Whisk egg yolks and sugar together in a heatproof bowl set over a pot of barely simmering water. Whisk constantly until the mixture reaches 160 degrees F and is thick and pale, about 8 minutes. Remove from heat and let cool for 5 minutes.', timerMinutes: 8 },
      { order: 2, instruction: 'Add the mascarpone to the egg yolk mixture and fold gently until smooth and combined.', timerMinutes: null },
      { order: 3, instruction: 'In a separate chilled bowl, whip the heavy cream and vanilla with an electric mixer until stiff peaks form. Gently fold the whipped cream into the mascarpone mixture in three additions until no streaks remain.', timerMinutes: null },
      { order: 4, instruction: 'Combine the cooled espresso and Marsala wine in a shallow dish. Quickly dip each ladyfinger into the espresso mixture, turning once. Do not soak them, just a quick 1-2 second dip on each side.', timerMinutes: null },
      { order: 5, instruction: 'Arrange a single layer of dipped ladyfingers in the bottom of a 9x13-inch dish. Spread half of the mascarpone cream evenly over the ladyfingers.', timerMinutes: null },
      { order: 6, instruction: 'Repeat with a second layer of dipped ladyfingers and the remaining cream. Smooth the top.', timerMinutes: null },
      { order: 7, instruction: 'Cover tightly with plastic wrap and refrigerate for at least 6 hours, or ideally overnight, to let the flavors meld and the texture set.', timerMinutes: 360 },
      { order: 8, instruction: 'Just before serving, dust the top generously with cocoa powder through a fine-mesh sieve. Cut into squares and serve cold.', timerMinutes: null },
    ],
    notes: 'Heating the egg yolks to 160 degrees F pasteurizes them for food safety. For an alcohol-free version, simply omit the Marsala. This tastes best on the second day.',

    communityRating: 4.9,
    communityRatingCount: 445,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },

  // ============================================================
  // FRENCH (5)
  // ============================================================
  {
    title: 'Coq au Vin',
    description:
      'A grand French braise of chicken slowly simmered in Burgundy wine with pearl onions, mushrooms, and smoky lardons until meltingly tender. The kind of dish that fills the whole house with warmth.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/coq-au-vin.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/coq-au-vin-prep.jpg', caption: 'Browning the chicken', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 6,
    prepTime: 30,
    cookTime: 90,
    totalTime: 120,
    difficulty: 'hard',
    spiceLevel: 0,

    cuisine: 'French',
    region: 'Europe',
    country: 'France',

    categories: ['Dinner'],
    tags: ['high-protein', 'one-pot', 'comfort-food', 'sunday-dinner', 'date-night', 'make-ahead'],
    ageGroups: ['adult'],

    nutrition: {
      calories: 580,
      protein: 42,
      carbs: 18,
      fat: 30,
      fiber: 2,
      sugar: 4,
      sodium: 850,
      iron: 4.2,
    },

    ingredients: [
      { qty: 4, unit: 'lb', item: 'bone-in skin-on chicken pieces (thighs and drumsticks)', group: 'Chicken' },
      { qty: 6, unit: 'oz', item: 'thick-cut bacon or lardons, diced', group: 'Braise' },
      { qty: 1, unit: 'bottle (750 ml)', item: 'dry red Burgundy wine', group: 'Braise' },
      { qty: 8, unit: 'oz', item: 'cremini mushrooms, quartered', group: 'Braise' },
      { qty: 1, unit: 'cup', item: 'frozen pearl onions, thawed', group: 'Braise' },
      { qty: 2, unit: '', item: 'medium carrots, sliced into rounds', group: 'Braise' },
      { qty: 3, unit: '', item: 'cloves garlic, minced', group: 'Braise' },
      { qty: 2, unit: 'tbsp', item: 'tomato paste', group: 'Braise' },
      { qty: 1, unit: 'cup', item: 'chicken broth', group: 'Braise' },
      { qty: 2, unit: 'tbsp', item: 'all-purpose flour', group: 'Braise' },
      { qty: 2, unit: 'tbsp', item: 'unsalted butter', group: 'Braise' },
      { qty: 3, unit: '', item: 'fresh thyme sprigs', group: 'Braise' },
      { qty: 2, unit: '', item: 'bay leaves', group: 'Braise' },
      { qty: 2, unit: 'tbsp', item: 'fresh parsley, chopped', group: 'Garnish' },
      { qty: 1.5, unit: 'tsp', item: 'salt', group: 'Braise' },
      { qty: 1, unit: 'tsp', item: 'black pepper', group: 'Braise' },
    ],
    steps: [
      { order: 1, instruction: 'Season chicken pieces generously with salt and pepper. In a large Dutch oven over medium-high heat, cook the bacon until crispy, about 5 minutes. Remove bacon with a slotted spoon and set aside.', timerMinutes: 5 },
      { order: 2, instruction: 'Working in batches, sear the chicken pieces skin-side down in the bacon fat until deeply golden, about 4 minutes per side. Set chicken aside.', timerMinutes: 8 },
      { order: 3, instruction: 'Reduce heat to medium. Add the carrots, pearl onions, and mushrooms to the pot. Cook for 5 minutes until lightly browned. Add garlic and tomato paste, stir for 1 minute.', timerMinutes: 6 },
      { order: 4, instruction: 'Sprinkle flour over the vegetables and stir for 1 minute. Pour in the entire bottle of wine and the chicken broth, scraping up the browned bits from the bottom of the pot.', timerMinutes: null },
      { order: 5, instruction: 'Return the chicken and bacon to the pot. Add thyme sprigs and bay leaves. Bring to a boil, then reduce to a low simmer. Cover and cook for 1 hour until the chicken is fall-off-the-bone tender.', timerMinutes: 60 },
      { order: 6, instruction: 'Remove the chicken to a serving platter. Discard thyme stems and bay leaves. If the sauce is thin, simmer uncovered for 10 minutes to reduce. Stir in butter to enrich the sauce.', timerMinutes: 10 },
      { order: 7, instruction: 'Spoon the sauce and vegetables over the chicken. Garnish with fresh parsley and serve with crusty bread or mashed potatoes.', timerMinutes: null },
    ],
    notes: 'Use a wine you would actually drink. Marinating the chicken in the wine overnight is traditional and deepens the flavor, but is not strictly necessary. This dish reheats beautifully the next day.',

    communityRating: 4.7,
    communityRatingCount: 256,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Ratatouille',
    description:
      'A vibrant Provencal vegetable stew where eggplant, zucchini, peppers, and tomatoes meld into a fragrant, silky dish that celebrates the best of the summer garden.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/ratatouille.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/ratatouille-prep.jpg', caption: 'Sliced vegetables arranged in dish', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 6,
    prepTime: 25,
    cookTime: 55,
    totalTime: 80,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'French',
    region: 'Europe',
    country: 'France',

    categories: ['Dinner', 'Sides'],
    tags: ['vegetarian', 'vegan', 'gluten-free', 'dairy-free', 'high-fiber', 'low-calorie', 'meal-prep', 'make-ahead'],
    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 180,
      protein: 4,
      carbs: 22,
      fat: 10,
      fiber: 6,
      sugar: 12,
      sodium: 420,
      iron: 1.8,
    },

    ingredients: [
      { qty: 1, unit: '', item: 'medium eggplant, cut into 1/2-inch dice', group: 'Vegetables' },
      { qty: 2, unit: '', item: 'medium zucchini, cut into 1/2-inch dice', group: 'Vegetables' },
      { qty: 1, unit: '', item: 'yellow squash, cut into 1/2-inch dice', group: 'Vegetables' },
      { qty: 1, unit: '', item: 'red bell pepper, cut into 1/2-inch dice', group: 'Vegetables' },
      { qty: 1, unit: '', item: 'yellow bell pepper, cut into 1/2-inch dice', group: 'Vegetables' },
      { qty: 1, unit: '', item: 'large yellow onion, diced', group: 'Vegetables' },
      { qty: 4, unit: '', item: 'cloves garlic, minced', group: 'Vegetables' },
      { qty: 1, unit: 'can (28 oz)', item: 'whole peeled tomatoes, crushed by hand', group: 'Sauce' },
      { qty: 0.25, unit: 'cup', item: 'extra virgin olive oil, divided', group: 'Sauce' },
      { qty: 2, unit: 'tbsp', item: 'fresh basil, chiffonade', group: 'Herbs' },
      { qty: 1, unit: 'tbsp', item: 'fresh thyme leaves', group: 'Herbs' },
      { qty: 1, unit: 'tsp', item: 'herbes de Provence', group: 'Herbs' },
      { qty: 1.5, unit: 'tsp', item: 'salt', group: 'Sauce' },
      { qty: 0.5, unit: 'tsp', item: 'black pepper', group: 'Sauce' },
    ],
    steps: [
      { order: 1, instruction: 'Heat 2 tablespoons of olive oil in a large Dutch oven or deep skillet over medium-high heat. Sear the eggplant in a single layer until golden on two sides, about 5 minutes. Remove and set aside. Repeat with zucchini and yellow squash, adding oil as needed.', timerMinutes: 10 },
      { order: 2, instruction: 'Add the remaining olive oil to the pot. Saute the onion and bell peppers over medium heat until softened, about 6 minutes. Add garlic and cook for 1 minute.', timerMinutes: 7 },
      { order: 3, instruction: 'Stir in the crushed tomatoes, herbes de Provence, thyme, salt, and pepper. Bring to a gentle simmer.', timerMinutes: null },
      { order: 4, instruction: 'Return all the seared vegetables to the pot and stir gently to combine. Reduce heat to low, cover, and simmer for 35-40 minutes, stirring occasionally, until all vegetables are tender and the flavors have melded.', timerMinutes: 35 },
      { order: 5, instruction: 'Taste and adjust seasoning. Stir in fresh basil just before serving.', timerMinutes: null },
      { order: 6, instruction: 'Serve warm or at room temperature as a main course with crusty bread, or as a side dish alongside grilled fish or chicken.', timerMinutes: null },
    ],
    notes: 'Salting the eggplant cubes for 20 minutes before cooking draws out moisture and prevents them from absorbing too much oil. This is even better the next day as the flavors deepen overnight.',

    communityRating: 4.3,
    communityRatingCount: 178,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'French Onion Soup',
    description:
      'Deeply caramelized onions simmered in a rich beef broth, ladled into crocks, and topped with a bubbling cap of Gruyere-covered toast. Comfort food at its most elegant.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/french-onion-soup.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/french-onion-soup-prep.jpg', caption: 'Caramelizing the onions', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 15,
    cookTime: 75,
    totalTime: 90,
    difficulty: 'medium',
    spiceLevel: 0,

    cuisine: 'French',
    region: 'Europe',
    country: 'France',

    categories: ['Dinner', 'Soups & Stews'],
    tags: ['comfort-food', 'make-ahead', 'one-pot'],
    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 420,
      protein: 18,
      carbs: 38,
      fat: 22,
      fiber: 3,
      sugar: 12,
      sodium: 1100,
      iron: 2.8,
    },

    ingredients: [
      { qty: 4, unit: 'lb', item: 'yellow onions, halved and thinly sliced', group: 'Soup' },
      { qty: 3, unit: 'tbsp', item: 'unsalted butter', group: 'Soup' },
      { qty: 1, unit: 'tbsp', item: 'olive oil', group: 'Soup' },
      { qty: 1, unit: 'tsp', item: 'sugar', group: 'Soup' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Soup' },
      { qty: 0.5, unit: 'cup', item: 'dry sherry or white wine', group: 'Soup' },
      { qty: 6, unit: 'cups', item: 'beef broth', group: 'Soup' },
      { qty: 2, unit: 'cups', item: 'water', group: 'Soup' },
      { qty: 3, unit: '', item: 'fresh thyme sprigs', group: 'Soup' },
      { qty: 2, unit: '', item: 'bay leaves', group: 'Soup' },
      { qty: 0.5, unit: 'tsp', item: 'black pepper', group: 'Soup' },
      { qty: 8, unit: 'slices', item: 'French bread, about 3/4-inch thick', group: 'Topping' },
      { qty: 8, unit: 'oz', item: 'Gruyere cheese, grated', group: 'Topping' },
    ],
    steps: [
      { order: 1, instruction: 'Melt butter with olive oil in a large Dutch oven over medium heat. Add all the sliced onions, sugar, and salt. Stir to coat, then cook, stirring every 5-10 minutes, until the onions are deeply golden brown and caramelized. This takes 45-50 minutes; do not rush this step.', timerMinutes: 45 },
      { order: 2, instruction: 'Deglaze the pot with sherry, scraping up all the browned bits from the bottom. Cook until the liquid has mostly evaporated, about 2 minutes.', timerMinutes: 2 },
      { order: 3, instruction: 'Add beef broth, water, thyme, and bay leaves. Bring to a boil, then reduce to a simmer and cook uncovered for 20 minutes. Season with pepper. Remove thyme stems and bay leaves.', timerMinutes: 20 },
      { order: 4, instruction: 'Meanwhile, preheat the broiler. Toast the bread slices on a sheet pan under the broiler until golden on both sides, about 1-2 minutes per side. Watch carefully.', timerMinutes: 3 },
      { order: 5, instruction: 'Ladle the soup into oven-safe crocks or bowls set on a sheet pan. Float 2 toasted bread slices on top of each bowl and mound generously with grated Gruyere.', timerMinutes: null },
      { order: 6, instruction: 'Place under the broiler until the cheese is melted, bubbling, and golden brown, about 3-4 minutes. Watch carefully to prevent burning.', timerMinutes: 4 },
      { order: 7, instruction: 'Let cool for 2 minutes before serving. The crocks will be very hot.', timerMinutes: 2 },
    ],
    notes: 'Patience with the caramelization is everything. If the onions start to stick, add a splash of water and scrape the bottom. A mix of onion varieties (yellow, red, sweet) adds complexity.',

    communityRating: 4.8,
    communityRatingCount: 340,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Quiche Lorraine',
    description:
      'A flaky, buttery pastry shell filled with a silky custard of eggs, cream, smoky bacon, and Gruyere cheese. Equally perfect for a leisurely brunch or a light dinner with salad.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/quiche-lorraine.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/quiche-lorraine-prep.jpg', caption: 'Blind-baking the pastry shell', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 6,
    prepTime: 25,
    cookTime: 50,
    totalTime: 75,
    difficulty: 'medium',
    spiceLevel: 0,

    cuisine: 'French',
    region: 'Europe',
    country: 'France',

    categories: ['Lunch', 'Breakfast'],
    tags: ['high-protein', 'brunch', 'make-ahead', 'baking', 'party'],
    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 480,
      protein: 20,
      carbs: 24,
      fat: 34,
      fiber: 1,
      sugar: 3,
      sodium: 680,
      iron: 2.2,
    },

    ingredients: [
      { qty: 1, unit: '', item: 'pre-made 9-inch pie crust (or homemade)', group: 'Crust' },
      { qty: 6, unit: 'oz', item: 'thick-cut bacon, cut into lardons', group: 'Filling' },
      { qty: 4, unit: '', item: 'large eggs', group: 'Custard' },
      { qty: 1.5, unit: 'cups', item: 'heavy cream', group: 'Custard' },
      { qty: 0.5, unit: 'cup', item: 'whole milk', group: 'Custard' },
      { qty: 1.5, unit: 'cups', item: 'Gruyere cheese, grated', group: 'Filling' },
      { qty: 0.25, unit: 'tsp', item: 'nutmeg, freshly grated', group: 'Custard' },
      { qty: 0.5, unit: 'tsp', item: 'salt', group: 'Custard' },
      { qty: 0.25, unit: 'tsp', item: 'white pepper', group: 'Custard' },
      { qty: 1, unit: 'tbsp', item: 'fresh chives, minced', group: 'Garnish' },
    ],
    steps: [
      { order: 1, instruction: 'Preheat oven to 375 degrees F. Press the pie crust into a 9-inch fluted tart pan with a removable bottom. Prick the bottom with a fork, line with parchment, and fill with pie weights or dried beans. Blind-bake for 15 minutes, then remove the weights and parchment. Bake 5 more minutes until lightly golden.', timerMinutes: 20 },
      { order: 2, instruction: 'While the crust bakes, cook the bacon lardons in a skillet over medium heat until crispy and rendered, about 6 minutes. Drain on paper towels.', timerMinutes: 6 },
      { order: 3, instruction: 'In a large bowl, whisk together the eggs, heavy cream, milk, nutmeg, salt, and white pepper until smooth.', timerMinutes: null },
      { order: 4, instruction: 'Scatter the crispy bacon and two-thirds of the Gruyere evenly over the bottom of the blind-baked crust.', timerMinutes: null },
      { order: 5, instruction: 'Carefully pour the egg custard into the crust, filling it nearly to the top. Sprinkle the remaining Gruyere on top.', timerMinutes: null },
      { order: 6, instruction: 'Bake for 30-35 minutes until the custard is set around the edges but still slightly jiggly in the center. The top should be lightly golden.', timerMinutes: 33 },
      { order: 7, instruction: 'Let cool on a wire rack for at least 15 minutes before slicing. Garnish with chives. Serve warm or at room temperature.', timerMinutes: 15 },
    ],
    notes: 'Do not skip blind-baking the crust or it will be soggy. For a homemade crust, use a classic pate brisee recipe. The quiche can be made a day ahead and reheated at 300 degrees F for 15 minutes.',

    communityRating: 4.5,
    communityRatingCount: 214,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Creme Brulee',
    description:
      'Shatteringly crisp caramelized sugar atop a cool, impossibly smooth vanilla custard. A French bistro classic that feels indulgent yet effortless.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/creme-brulee.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/creme-brulee-prep.jpg', caption: 'Torching the sugar topping', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 6,
    prepTime: 15,
    cookTime: 50,
    totalTime: 65,
    difficulty: 'medium',
    spiceLevel: 0,

    cuisine: 'French',
    region: 'Europe',
    country: 'France',

    categories: ['Dessert'],
    tags: ['gluten-free', 'make-ahead', 'date-night', 'celebration', 'baking'],
    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 420,
      protein: 6,
      carbs: 32,
      fat: 30,
      fiber: 0,
      sugar: 28,
      sodium: 65,
      iron: 0.8,
    },

    ingredients: [
      { qty: 2, unit: 'cups', item: 'heavy cream', group: 'Custard' },
      { qty: 5, unit: '', item: 'large egg yolks', group: 'Custard' },
      { qty: 0.5, unit: 'cup', item: 'granulated sugar', group: 'Custard' },
      { qty: 1, unit: '', item: 'vanilla bean, split and scraped (or 2 tsp extract)', group: 'Custard' },
      { qty: 1, unit: 'pinch', item: 'salt', group: 'Custard' },
      { qty: 6, unit: 'tbsp', item: 'superfine sugar, for topping', group: 'Topping' },
    ],
    steps: [
      { order: 1, instruction: 'Preheat oven to 325 degrees F. Place six 6-oz ramekins in a deep baking pan.', timerMinutes: null },
      { order: 2, instruction: 'Heat heavy cream with the vanilla bean pod and seeds in a saucepan over medium heat until it just begins to simmer around the edges. Do not boil. Remove from heat, cover, and steep for 10 minutes.', timerMinutes: 10 },
      { order: 3, instruction: 'Whisk egg yolks with the 1/2 cup sugar and salt until pale and slightly thickened. Slowly pour the warm cream through a fine-mesh strainer into the yolk mixture, whisking constantly to temper without scrambling the eggs.', timerMinutes: null },
      { order: 4, instruction: 'Divide the custard evenly among the ramekins. Pour hot water into the baking pan until it reaches halfway up the sides of the ramekins.', timerMinutes: null },
      { order: 5, instruction: 'Bake for 40-45 minutes until the custards are set around the edges but still jiggle slightly in the center when gently shaken.', timerMinutes: 42 },
      { order: 6, instruction: 'Carefully remove ramekins from the water bath. Let cool to room temperature, then refrigerate for at least 4 hours or overnight.', timerMinutes: 240 },
      { order: 7, instruction: 'Just before serving, sprinkle 1 tablespoon of superfine sugar evenly over each custard. Use a kitchen torch to caramelize the sugar until it forms a deep amber, crackly shell. Let sit for 1 minute to harden, then serve.', timerMinutes: null },
    ],
    notes: 'If you do not have a kitchen torch, place the ramekins under a very hot broiler for 1-2 minutes, watching constantly. The custards must be cold when you torch them so the sugar hardens properly.',

    communityRating: 4.8,
    communityRatingCount: 368,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },

  // ============================================================
  // SPANISH (3)
  // ============================================================
  {
    title: 'Paella',
    description:
      'A festive Spanish rice dish from Valencia loaded with saffron-scented rice, chicken, chorizo, shrimp, and mussels, crowned with a prized crispy socarrat on the bottom.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/paella.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/paella-prep.jpg', caption: 'Arranging seafood on the rice', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 6,
    prepTime: 30,
    cookTime: 45,
    totalTime: 75,
    difficulty: 'hard',
    spiceLevel: 1,

    cuisine: 'Spanish',
    region: 'Europe',
    country: 'Spain',

    categories: ['Dinner'],
    tags: ['high-protein', 'gluten-free', 'dairy-free', 'one-pan', 'party', 'celebration', 'pescatarian'],
    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 620,
      protein: 38,
      carbs: 56,
      fat: 24,
      fiber: 3,
      sugar: 4,
      sodium: 980,
      iron: 5.2,
    },

    ingredients: [
      { qty: 2, unit: 'cups', item: 'bomba or Calasparra rice (or Arborio)', group: 'Rice' },
      { qty: 4, unit: 'cups', item: 'chicken broth, warmed', group: 'Rice' },
      { qty: 0.5, unit: 'tsp', item: 'saffron threads', group: 'Rice' },
      { qty: 1, unit: 'lb', item: 'bone-in chicken thighs, cut into pieces', group: 'Protein' },
      { qty: 6, unit: 'oz', item: 'Spanish chorizo, sliced into rounds', group: 'Protein' },
      { qty: 0.75, unit: 'lb', item: 'large shrimp, peeled and deveined', group: 'Protein' },
      { qty: 12, unit: '', item: 'mussels, scrubbed and debearded', group: 'Protein' },
      { qty: 1, unit: '', item: 'large yellow onion, diced', group: 'Sofrito' },
      { qty: 1, unit: '', item: 'red bell pepper, diced', group: 'Sofrito' },
      { qty: 4, unit: '', item: 'cloves garlic, minced', group: 'Sofrito' },
      { qty: 1, unit: 'can (14.5 oz)', item: 'diced tomatoes', group: 'Sofrito' },
      { qty: 1, unit: 'tsp', item: 'smoked paprika', group: 'Sofrito' },
      { qty: 3, unit: 'tbsp', item: 'olive oil', group: 'Sofrito' },
      { qty: 0.5, unit: 'cup', item: 'frozen peas', group: 'Vegetables' },
      { qty: 1, unit: '', item: 'lemon, cut into wedges', group: 'Garnish' },
      { qty: 2, unit: 'tbsp', item: 'fresh parsley, chopped', group: 'Garnish' },
      { qty: 1.5, unit: 'tsp', item: 'salt', group: 'Rice' },
    ],
    steps: [
      { order: 1, instruction: 'Steep saffron in the warm broth for at least 10 minutes. Season chicken pieces with salt and smoked paprika.', timerMinutes: 10 },
      { order: 2, instruction: 'Heat olive oil in a 15-inch paella pan or large skillet over medium-high heat. Sear chicken pieces until golden brown on all sides, about 6 minutes. Remove and set aside.', timerMinutes: 6 },
      { order: 3, instruction: 'In the same pan, cook chorizo slices until lightly crisped, about 2 minutes. Remove and set aside with the chicken.', timerMinutes: 2 },
      { order: 4, instruction: 'Add onion and bell pepper to the pan. Cook for 5 minutes until softened. Add garlic and cook 1 minute. Stir in the diced tomatoes and cook until most of the liquid evaporates, about 4 minutes.', timerMinutes: 10 },
      { order: 5, instruction: 'Add the rice to the pan and stir to coat in the sofrito for 2 minutes. Pour in the saffron broth and season with salt. Nestle the chicken and chorizo into the rice. Bring to a boil, then reduce to medium-low. Do not stir from this point forward.', timerMinutes: null },
      { order: 6, instruction: 'Cook uncovered for 18 minutes until the rice has absorbed most of the liquid. After 12 minutes, arrange the shrimp and mussels on top of the rice, pushing them in slightly. Scatter peas around the pan.', timerMinutes: 18 },
      { order: 7, instruction: 'Increase heat to medium-high for the last 2 minutes to develop the socarrat (crispy bottom layer). You should hear a gentle crackling. Remove from heat.', timerMinutes: 2 },
      { order: 8, instruction: 'Cover the pan with a clean kitchen towel or foil and let rest for 5 minutes. Discard any mussels that did not open. Garnish with parsley and lemon wedges.', timerMinutes: 5 },
    ],
    notes: 'The key to socarrat is resisting the urge to stir. If you cannot find bomba rice, Arborio works but will be slightly creamier. Use the widest pan you have so the rice cooks in a thin, even layer.',

    communityRating: 4.7,
    communityRatingCount: 312,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Gazpacho',
    description:
      'An ice-cold Spanish soup made from ripe tomatoes, cucumbers, and peppers blended to a velvety smooth finish with sherry vinegar and olive oil. Summer in a bowl.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/gazpacho.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/gazpacho-prep.jpg', caption: 'Fresh vegetables before blending', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 6,
    prepTime: 20,
    cookTime: 0,
    totalTime: 20,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'Spanish',
    region: 'Europe',
    country: 'Spain',

    categories: ['Soups & Stews', 'Lunch', 'Appetizers'],
    tags: ['vegetarian', 'vegan', 'gluten-free', 'dairy-free', 'no-cook', 'low-calorie', 'high-fiber', 'under-30-min', 'make-ahead'],
    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 140,
      protein: 3,
      carbs: 16,
      fat: 8,
      fiber: 3,
      sugar: 10,
      sodium: 380,
      iron: 1.4,
    },

    ingredients: [
      { qty: 2, unit: 'lb', item: 'ripe tomatoes, cored and roughly chopped', group: 'Soup' },
      { qty: 1, unit: '', item: 'English cucumber, peeled and chopped', group: 'Soup' },
      { qty: 1, unit: '', item: 'red bell pepper, seeded and chopped', group: 'Soup' },
      { qty: 0.5, unit: '', item: 'small red onion, chopped', group: 'Soup' },
      { qty: 2, unit: '', item: 'cloves garlic', group: 'Soup' },
      { qty: 1, unit: 'slice', item: 'day-old white bread, crust removed, torn', group: 'Soup' },
      { qty: 3, unit: 'tbsp', item: 'extra virgin olive oil, plus more for drizzling', group: 'Soup' },
      { qty: 2, unit: 'tbsp', item: 'sherry vinegar', group: 'Soup' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Soup' },
      { qty: 0.25, unit: 'tsp', item: 'black pepper', group: 'Soup' },
      { qty: 0.25, unit: 'cup', item: 'cucumber, finely diced', group: 'Garnish' },
      { qty: 0.25, unit: 'cup', item: 'red bell pepper, finely diced', group: 'Garnish' },
      { qty: 1, unit: 'tbsp', item: 'fresh basil or parsley, minced', group: 'Garnish' },
    ],
    steps: [
      { order: 1, instruction: 'Combine tomatoes, cucumber, bell pepper, red onion, garlic, and torn bread in a large bowl. Let sit for 10 minutes so the bread softens and absorbs the juices.', timerMinutes: 10 },
      { order: 2, instruction: 'Transfer the mixture to a blender in batches. Blend on high until completely smooth, about 2 minutes per batch.', timerMinutes: null },
      { order: 3, instruction: 'With the blender running, drizzle in olive oil and sherry vinegar. Season with salt and pepper.', timerMinutes: null },
      { order: 4, instruction: 'Strain through a medium-mesh sieve for a silky texture, pressing on solids. Discard the pulp. Alternatively, leave unstrained for a more rustic consistency.', timerMinutes: null },
      { order: 5, instruction: 'Taste and adjust seasoning, adding more vinegar or salt as needed. Cover and refrigerate for at least 2 hours until well chilled.', timerMinutes: 120 },
      { order: 6, instruction: 'Serve in chilled bowls, topped with diced cucumber, bell pepper, a drizzle of olive oil, and fresh herbs.', timerMinutes: null },
    ],
    notes: 'Use the ripest, most flavorful tomatoes you can find. In winter, a mix of canned San Marzano tomatoes and fresh vegetables works well. This keeps in the refrigerator for up to 3 days.',

    communityRating: 4.2,
    communityRatingCount: 156,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Patatas Bravas',
    description:
      'Crispy fried potato cubes served with a bold, smoky tomato sauce and creamy garlic aioli. Spain\'s most beloved tapas dish, perfect for sharing over drinks.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/patatas-bravas.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/patatas-bravas-prep.jpg', caption: 'Frying the potatoes', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 15,
    cookTime: 30,
    totalTime: 45,
    difficulty: 'easy',
    spiceLevel: 2,

    cuisine: 'Spanish',
    region: 'Europe',
    country: 'Spain',

    categories: ['Appetizers', 'Sides', 'Snacks'],
    tags: ['vegetarian', 'gluten-free', 'party', 'game-day', 'budget-friendly'],
    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 340,
      protein: 5,
      carbs: 42,
      fat: 18,
      fiber: 4,
      sugar: 5,
      sodium: 580,
      iron: 1.6,
    },

    ingredients: [
      { qty: 2, unit: 'lb', item: 'Yukon Gold potatoes, peeled and cut into 1-inch cubes', group: 'Potatoes' },
      { qty: 0.5, unit: 'cup', item: 'olive oil, for frying', group: 'Potatoes' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Potatoes' },
      { qty: 1, unit: 'can (14.5 oz)', item: 'crushed tomatoes', group: 'Brava Sauce' },
      { qty: 2, unit: 'tbsp', item: 'olive oil', group: 'Brava Sauce' },
      { qty: 2, unit: '', item: 'cloves garlic, minced', group: 'Brava Sauce' },
      { qty: 1.5, unit: 'tsp', item: 'smoked paprika (pimenton)', group: 'Brava Sauce' },
      { qty: 0.5, unit: 'tsp', item: 'cayenne pepper', group: 'Brava Sauce' },
      { qty: 1, unit: 'tsp', item: 'sherry vinegar', group: 'Brava Sauce' },
      { qty: 0.5, unit: 'tsp', item: 'sugar', group: 'Brava Sauce' },
      { qty: 0.5, unit: 'cup', item: 'mayonnaise', group: 'Aioli' },
      { qty: 2, unit: '', item: 'cloves garlic, finely grated', group: 'Aioli' },
      { qty: 1, unit: 'tbsp', item: 'lemon juice', group: 'Aioli' },
      { qty: 1, unit: 'tbsp', item: 'fresh parsley, chopped', group: 'Garnish' },
    ],
    steps: [
      { order: 1, instruction: 'Place potato cubes in a pot of cold salted water. Bring to a boil and cook until just tender but not falling apart, about 10 minutes. Drain thoroughly and let steam dry for 5 minutes.', timerMinutes: 15 },
      { order: 2, instruction: 'Make the brava sauce: heat 2 tablespoons olive oil in a small saucepan over medium heat. Add garlic and cook for 30 seconds. Add smoked paprika and cayenne, stirring for 15 seconds. Add crushed tomatoes, sugar, and a pinch of salt. Simmer for 10 minutes until thickened. Stir in sherry vinegar and set aside.', timerMinutes: 10 },
      { order: 3, instruction: 'Make the aioli: whisk together mayonnaise, grated garlic, lemon juice, and a pinch of salt in a small bowl. Refrigerate until serving.', timerMinutes: null },
      { order: 4, instruction: 'Heat 1/2 cup olive oil in a large skillet over medium-high heat until shimmering. Fry the parboiled potatoes in a single layer, turning occasionally, until golden and crispy on all sides, about 10-12 minutes. Work in batches to avoid crowding. Drain on paper towels and season with salt.', timerMinutes: 12 },
      { order: 5, instruction: 'Pile the crispy potatoes on a serving platter. Drizzle generously with the warm brava sauce and dollop the aioli on top. Garnish with fresh parsley.', timerMinutes: null },
    ],
    notes: 'For an even crispier result, toss the parboiled potatoes with a tablespoon of cornstarch before frying. The bravas sauce can be made ahead and reheated.',

    communityRating: 4.6,
    communityRatingCount: 245,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },

  // ============================================================
  // GREEK (4)
  // ============================================================
  {
    title: 'Moussaka',
    description:
      'A magnificent Greek casserole layering silky roasted eggplant, richly spiced lamb ragu, and a golden, cloud-like bechamel topping. A dish worthy of a celebration.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/moussaka.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/moussaka-prep.jpg', caption: 'Layering the eggplant slices', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 8,
    prepTime: 40,
    cookTime: 60,
    totalTime: 100,
    difficulty: 'hard',
    spiceLevel: 1,

    cuisine: 'Greek',
    region: 'Europe',
    country: 'Greece',

    categories: ['Dinner'],
    tags: ['high-protein', 'comfort-food', 'sunday-dinner', 'make-ahead', 'freezer-friendly'],
    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 520,
      protein: 28,
      carbs: 26,
      fat: 34,
      fiber: 5,
      sugar: 9,
      sodium: 720,
      iron: 3.8,
    },

    ingredients: [
      { qty: 3, unit: '', item: 'large eggplants, sliced into 1/4-inch rounds', group: 'Eggplant' },
      { qty: 3, unit: 'tbsp', item: 'olive oil', group: 'Eggplant' },
      { qty: 1.5, unit: 'lb', item: 'ground lamb (or beef)', group: 'Meat Sauce' },
      { qty: 1, unit: '', item: 'large yellow onion, diced', group: 'Meat Sauce' },
      { qty: 3, unit: '', item: 'cloves garlic, minced', group: 'Meat Sauce' },
      { qty: 1, unit: 'can (14.5 oz)', item: 'crushed tomatoes', group: 'Meat Sauce' },
      { qty: 2, unit: 'tbsp', item: 'tomato paste', group: 'Meat Sauce' },
      { qty: 0.5, unit: 'cup', item: 'dry red wine', group: 'Meat Sauce' },
      { qty: 1, unit: 'tsp', item: 'ground cinnamon', group: 'Meat Sauce' },
      { qty: 0.5, unit: 'tsp', item: 'ground allspice', group: 'Meat Sauce' },
      { qty: 1, unit: 'tsp', item: 'dried oregano', group: 'Meat Sauce' },
      { qty: 1, unit: '', item: 'bay leaf', group: 'Meat Sauce' },
      { qty: 4, unit: 'tbsp', item: 'unsalted butter', group: 'Bechamel' },
      { qty: 0.33, unit: 'cup', item: 'all-purpose flour', group: 'Bechamel' },
      { qty: 3, unit: 'cups', item: 'whole milk, warmed', group: 'Bechamel' },
      { qty: 0.25, unit: 'tsp', item: 'nutmeg', group: 'Bechamel' },
      { qty: 2, unit: '', item: 'large egg yolks', group: 'Bechamel' },
      { qty: 0.5, unit: 'cup', item: 'Parmesan cheese, grated', group: 'Bechamel' },
      { qty: 1.5, unit: 'tsp', item: 'salt, divided', group: 'Meat Sauce' },
      { qty: 0.5, unit: 'tsp', item: 'black pepper', group: 'Meat Sauce' },
    ],
    steps: [
      { order: 1, instruction: 'Preheat oven to 400 degrees F. Arrange eggplant slices on sheet pans, brush both sides with olive oil, and season with salt. Roast for 20 minutes, flipping halfway, until golden and tender. Reduce oven to 375 degrees F.', timerMinutes: 20 },
      { order: 2, instruction: 'While eggplant roasts, heat a large skillet over medium-high heat. Brown the ground lamb, breaking it up, for 6 minutes. Drain excess fat. Add onion and cook 4 minutes. Add garlic, cook 1 minute.', timerMinutes: 11 },
      { order: 3, instruction: 'Add wine to deglaze and cook until reduced by half. Stir in crushed tomatoes, tomato paste, cinnamon, allspice, oregano, bay leaf, salt, and pepper. Simmer for 15 minutes until thick. Remove bay leaf.', timerMinutes: 15 },
      { order: 4, instruction: 'Make the bechamel: melt butter in a medium saucepan over medium heat. Whisk in flour and cook for 2 minutes. Gradually whisk in warm milk, stirring constantly until thick and smooth, about 5 minutes. Remove from heat, stir in nutmeg and Parmesan. Let cool slightly, then whisk in egg yolks.', timerMinutes: 7 },
      { order: 5, instruction: 'Layer the moussaka in a 9x13-inch baking dish: half the eggplant slices on the bottom, then all the meat sauce, then the remaining eggplant. Pour the bechamel evenly over the top and spread smooth.', timerMinutes: null },
      { order: 6, instruction: 'Bake at 375 degrees F for 35-40 minutes until the top is golden brown and the casserole is bubbling at the edges.', timerMinutes: 38 },
      { order: 7, instruction: 'Let rest for at least 20 minutes before cutting. This is critical for clean slices.', timerMinutes: 20 },
    ],
    notes: 'The resting time is not optional; the moussaka will fall apart if cut too soon. You can assemble it fully the day before and refrigerate, then bake an extra 10 minutes from cold.',

    communityRating: 4.6,
    communityRatingCount: 203,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Spanakopita',
    description:
      'Flaky, golden phyllo pastry encasing a savory filling of spinach, tangy feta, and fresh herbs. These crispy triangles are irresistible as an appetizer or light lunch.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/spanakopita.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/spanakopita-prep.jpg', caption: 'Folding the phyllo triangles', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 6,
    prepTime: 35,
    cookTime: 25,
    totalTime: 60,
    difficulty: 'medium',
    spiceLevel: 0,

    cuisine: 'Greek',
    region: 'Europe',
    country: 'Greece',

    categories: ['Appetizers', 'Lunch', 'Snacks'],
    tags: ['vegetarian', 'high-iron', 'baking', 'party', 'make-ahead', 'freezer-friendly'],
    ageGroups: ['kid', 'teen', 'adult'],

    nutrition: {
      calories: 320,
      protein: 14,
      carbs: 26,
      fat: 19,
      fiber: 3,
      sugar: 2,
      sodium: 620,
      iron: 4.0,
    },

    ingredients: [
      { qty: 1, unit: 'lb', item: 'fresh spinach, washed and stems removed', group: 'Filling' },
      { qty: 8, unit: 'oz', item: 'feta cheese, crumbled', group: 'Filling' },
      { qty: 0.5, unit: 'cup', item: 'ricotta cheese', group: 'Filling' },
      { qty: 1, unit: '', item: 'small yellow onion, finely diced', group: 'Filling' },
      { qty: 3, unit: '', item: 'scallions, thinly sliced', group: 'Filling' },
      { qty: 2, unit: '', item: 'large eggs, beaten', group: 'Filling' },
      { qty: 0.25, unit: 'cup', item: 'fresh dill, chopped', group: 'Filling' },
      { qty: 0.25, unit: 'tsp', item: 'nutmeg', group: 'Filling' },
      { qty: 0.5, unit: 'tsp', item: 'salt', group: 'Filling' },
      { qty: 0.5, unit: 'tsp', item: 'black pepper', group: 'Filling' },
      { qty: 12, unit: 'sheets', item: 'phyllo dough, thawed according to package directions', group: 'Pastry' },
      { qty: 0.5, unit: 'cup', item: 'unsalted butter, melted', group: 'Pastry' },
      { qty: 1, unit: 'tbsp', item: 'sesame seeds', group: 'Pastry' },
    ],
    steps: [
      { order: 1, instruction: 'Wilt the spinach in a large skillet over medium heat with a splash of water for 3 minutes. Transfer to a colander, press out all excess moisture with the back of a spoon, then roughly chop.', timerMinutes: 3 },
      { order: 2, instruction: 'Saute the diced onion in 1 tablespoon of the melted butter over medium heat until soft, about 4 minutes. Let cool slightly.', timerMinutes: 4 },
      { order: 3, instruction: 'In a large bowl, combine the spinach, sauteed onion, scallions, feta, ricotta, eggs, dill, nutmeg, salt, and pepper. Mix until evenly combined.', timerMinutes: null },
      { order: 4, instruction: 'Preheat oven to 375 degrees F. Line a baking sheet with parchment paper. Lay one sheet of phyllo on a clean surface and brush lightly with melted butter. Top with a second sheet and brush again. Cut the double layer lengthwise into 3 equal strips.', timerMinutes: null },
      { order: 5, instruction: 'Place 2 tablespoons of filling at the bottom corner of each strip. Fold corner to corner in a triangle, then continue folding up the strip maintaining the triangle shape. Place seam-side down on the baking sheet. Repeat with remaining phyllo and filling.', timerMinutes: null },
      { order: 6, instruction: 'Brush the tops of the triangles with melted butter and sprinkle with sesame seeds. Bake for 22-25 minutes until deep golden brown and flaky.', timerMinutes: 24 },
      { order: 7, instruction: 'Let cool for 5 minutes before serving. Serve warm with lemon wedges and tzatziki on the side.', timerMinutes: 5 },
    ],
    notes: 'Keep unused phyllo covered with a damp towel while working so it does not dry out. These freeze beautifully unbaked: freeze on a sheet pan, then transfer to a bag. Bake from frozen, adding 5 minutes to the time.',

    communityRating: 4.5,
    communityRatingCount: 189,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Greek Salad',
    description:
      'A bright, refreshing salad of ripe tomatoes, crisp cucumbers, briny olives, and creamy feta dressed simply with olive oil and oregano. The taste of a Greek summer.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/greek-salad.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/greek-salad-prep.jpg', caption: 'Chopping the vegetables', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 15,
    cookTime: 0,
    totalTime: 15,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'Greek',
    region: 'Europe',
    country: 'Greece',

    categories: ['Salads', 'Sides', 'Lunch'],
    tags: ['vegetarian', 'gluten-free', 'low-carb', 'low-calorie', 'no-cook', 'under-15-min', 'budget-friendly'],
    ageGroups: ['kid', 'teen', 'adult'],

    nutrition: {
      calories: 240,
      protein: 8,
      carbs: 12,
      fat: 19,
      fiber: 3,
      sugar: 7,
      sodium: 680,
      iron: 1.4,
    },

    ingredients: [
      { qty: 4, unit: '', item: 'medium ripe tomatoes, cut into wedges', group: 'Salad' },
      { qty: 1, unit: '', item: 'English cucumber, halved and sliced into half-moons', group: 'Salad' },
      { qty: 1, unit: '', item: 'green bell pepper, sliced into rings', group: 'Salad' },
      { qty: 0.5, unit: '', item: 'red onion, thinly sliced into rings', group: 'Salad' },
      { qty: 0.5, unit: 'cup', item: 'Kalamata olives', group: 'Salad' },
      { qty: 6, unit: 'oz', item: 'feta cheese, cut into a thick slab or large crumbles', group: 'Salad' },
      { qty: 3, unit: 'tbsp', item: 'extra virgin olive oil', group: 'Dressing' },
      { qty: 1, unit: 'tbsp', item: 'red wine vinegar', group: 'Dressing' },
      { qty: 1, unit: 'tsp', item: 'dried oregano', group: 'Dressing' },
      { qty: 0.5, unit: 'tsp', item: 'salt', group: 'Dressing' },
      { qty: 0.25, unit: 'tsp', item: 'black pepper', group: 'Dressing' },
    ],
    steps: [
      { order: 1, instruction: 'Arrange the tomato wedges, cucumber slices, bell pepper rings, and red onion rings on a large serving platter or in a wide, shallow bowl.', timerMinutes: null },
      { order: 2, instruction: 'Scatter the Kalamata olives over the vegetables.', timerMinutes: null },
      { order: 3, instruction: 'Place the slab of feta prominently on top of the salad, or crumble it over in large pieces.', timerMinutes: null },
      { order: 4, instruction: 'Drizzle the extra virgin olive oil and red wine vinegar evenly over the salad. Season with dried oregano, salt, and pepper.', timerMinutes: null },
      { order: 5, instruction: 'Serve immediately with crusty bread to soak up the juices. Do not toss the salad; let each person mix it on their plate.', timerMinutes: null },
    ],
    notes: 'A traditional Greek salad (horiatiki) never includes lettuce. Use the best quality olive oil, feta, and tomatoes you can find, as the dish relies on the quality of each simple ingredient.',

    communityRating: 4.4,
    communityRatingCount: 278,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Baklava',
    description:
      'Layers upon layers of crisp, buttery phyllo pastry and crunchy walnuts drenched in a fragrant honey-cinnamon syrup. An iconic Greek and Mediterranean sweet that is utterly addictive.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/baklava.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/baklava-prep.jpg', caption: 'Layering phyllo and nuts', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 24,
    prepTime: 30,
    cookTime: 50,
    totalTime: 80,
    difficulty: 'medium',
    spiceLevel: 0,

    cuisine: 'Greek',
    region: 'Europe',
    country: 'Greece',

    categories: ['Dessert', 'Snacks'],
    tags: ['make-ahead', 'party', 'celebration', 'holiday', 'baking'],
    ageGroups: ['kid', 'teen', 'adult'],

    nutrition: {
      calories: 280,
      protein: 4,
      carbs: 32,
      fat: 16,
      fiber: 1,
      sugar: 20,
      sodium: 110,
      iron: 1.0,
    },

    ingredients: [
      { qty: 1, unit: 'lb', item: 'phyllo dough, thawed', group: 'Pastry' },
      { qty: 1, unit: 'cup', item: 'unsalted butter, melted', group: 'Pastry' },
      { qty: 3, unit: 'cups', item: 'walnuts, finely chopped', group: 'Filling' },
      { qty: 0.5, unit: 'cup', item: 'pistachios, finely chopped', group: 'Filling' },
      { qty: 1, unit: 'tsp', item: 'ground cinnamon', group: 'Filling' },
      { qty: 0.25, unit: 'tsp', item: 'ground cloves', group: 'Filling' },
      { qty: 1, unit: 'cup', item: 'granulated sugar', group: 'Syrup' },
      { qty: 0.75, unit: 'cup', item: 'water', group: 'Syrup' },
      { qty: 0.5, unit: 'cup', item: 'honey', group: 'Syrup' },
      { qty: 1, unit: 'tbsp', item: 'lemon juice', group: 'Syrup' },
      { qty: 1, unit: 'strip', item: 'orange peel', group: 'Syrup' },
      { qty: 1, unit: '', item: 'cinnamon stick', group: 'Syrup' },
    ],
    steps: [
      { order: 1, instruction: 'Preheat oven to 350 degrees F. Butter a 9x13-inch baking pan. Mix chopped walnuts, pistachios, cinnamon, and cloves in a bowl.', timerMinutes: null },
      { order: 2, instruction: 'Trim phyllo sheets to fit the pan. Layer 8 sheets in the pan, brushing each sheet generously with melted butter. Spread 1/3 of the nut mixture evenly over the phyllo.', timerMinutes: null },
      { order: 3, instruction: 'Layer 6 more phyllo sheets, buttering each one, then spread another 1/3 of the nut mixture. Repeat once more: 6 buttered sheets and the remaining nuts. Finish with 8 sheets of phyllo, buttering each one generously, especially the top.', timerMinutes: null },
      { order: 4, instruction: 'Using a sharp knife, cut the baklava into diamond or square shapes, cutting all the way through to the bottom of the pan. This must be done before baking.', timerMinutes: null },
      { order: 5, instruction: 'Bake for 45-50 minutes until the top is deep golden brown and the layers are crisp. If the top browns too quickly, tent loosely with foil.', timerMinutes: 48 },
      { order: 6, instruction: 'While the baklava bakes, make the syrup: combine sugar, water, honey, lemon juice, orange peel, and cinnamon stick in a saucepan. Bring to a boil, then simmer for 10 minutes. Remove the orange peel and cinnamon stick. Let the syrup cool completely.', timerMinutes: 10 },
      { order: 7, instruction: 'As soon as the baklava comes out of the oven, immediately pour the cool syrup slowly and evenly over the hot pastry. You will hear it sizzle. Let it sit uncovered at room temperature for at least 4 hours to absorb the syrup before serving.', timerMinutes: 240 },
    ],
    notes: 'The key rule: hot baklava, cold syrup (or vice versa). This prevents sogginess and ensures a crisp result. Store uncovered at room temperature for up to 1 week; do not refrigerate or it will lose its crispness.',

    communityRating: 4.9,
    communityRatingCount: 402,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },

  // ============================================================
  // BRITISH (3)
  // ============================================================
  {
    title: "Shepherd's Pie",
    description:
      'A hearty British classic of savory lamb mince braised with vegetables in a rich gravy, topped with creamy mashed potatoes baked until golden and bubbling.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/shepherds-pie.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/shepherds-pie-prep.jpg', caption: 'Piping the mashed potato topping', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 6,
    prepTime: 25,
    cookTime: 45,
    totalTime: 70,
    difficulty: 'medium',
    spiceLevel: 0,

    cuisine: 'British',
    region: 'Europe',
    country: 'United Kingdom',

    categories: ['Dinner', 'Family Meals'],
    tags: ['high-protein', 'comfort-food', 'family-friendly', 'make-ahead', 'freezer-friendly', 'one-pan'],
    ageGroups: ['kid', 'teen', 'adult'],
    audience: 'family',

    nutrition: {
      calories: 540,
      protein: 30,
      carbs: 42,
      fat: 26,
      fiber: 5,
      sugar: 6,
      sodium: 780,
      iron: 3.6,
    },

    ingredients: [
      { qty: 2, unit: 'lb', item: 'russet potatoes, peeled and quartered', group: 'Mash' },
      { qty: 4, unit: 'tbsp', item: 'unsalted butter', group: 'Mash' },
      { qty: 0.5, unit: 'cup', item: 'whole milk, warmed', group: 'Mash' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Mash' },
      { qty: 1.5, unit: 'lb', item: 'ground lamb', group: 'Filling' },
      { qty: 1, unit: '', item: 'large yellow onion, diced', group: 'Filling' },
      { qty: 2, unit: '', item: 'medium carrots, diced', group: 'Filling' },
      { qty: 2, unit: '', item: 'celery stalks, diced', group: 'Filling' },
      { qty: 1, unit: 'cup', item: 'frozen peas', group: 'Filling' },
      { qty: 2, unit: '', item: 'cloves garlic, minced', group: 'Filling' },
      { qty: 2, unit: 'tbsp', item: 'tomato paste', group: 'Filling' },
      { qty: 2, unit: 'tbsp', item: 'all-purpose flour', group: 'Filling' },
      { qty: 1, unit: 'cup', item: 'beef broth', group: 'Filling' },
      { qty: 1, unit: 'tbsp', item: 'Worcestershire sauce', group: 'Filling' },
      { qty: 2, unit: '', item: 'fresh rosemary sprigs, leaves minced', group: 'Filling' },
      { qty: 2, unit: '', item: 'fresh thyme sprigs', group: 'Filling' },
      { qty: 0.5, unit: 'tsp', item: 'black pepper', group: 'Filling' },
    ],
    steps: [
      { order: 1, instruction: 'Boil the potatoes in salted water until fork-tender, about 15 minutes. Drain well, then mash with butter, warm milk, and salt until smooth and creamy. Set aside.', timerMinutes: 15 },
      { order: 2, instruction: 'Preheat oven to 400 degrees F. Brown the lamb in a large oven-safe skillet over medium-high heat, breaking it into small pieces, for about 6 minutes. Drain off excess fat, leaving 1 tablespoon.', timerMinutes: 6 },
      { order: 3, instruction: 'Add onion, carrots, and celery to the lamb. Cook for 5 minutes until softened. Add garlic and cook 1 minute. Stir in tomato paste and flour, cooking for 1 minute.', timerMinutes: 7 },
      { order: 4, instruction: 'Pour in the beef broth and Worcestershire sauce. Add rosemary and thyme. Stir well and simmer for 8 minutes until the gravy has thickened. Stir in the frozen peas. Season with salt and pepper. Remove thyme stems.', timerMinutes: 8 },
      { order: 5, instruction: 'Spread the mashed potatoes evenly over the lamb filling. Use a fork to create ridges on top, which will crisp up in the oven. Dot with small pieces of butter.', timerMinutes: null },
      { order: 6, instruction: 'Bake for 25 minutes until the top is golden brown and the filling is bubbling around the edges.', timerMinutes: 25 },
      { order: 7, instruction: 'Let rest for 10 minutes before serving. This allows the filling to set so it does not run when scooped.', timerMinutes: 10 },
    ],
    notes: 'True shepherd\'s pie uses lamb; with beef it becomes cottage pie. For extra richness, add an egg yolk to the mashed potatoes. The filling should be slightly saucy before topping, as it will thicken further in the oven.',

    communityRating: 4.6,
    communityRatingCount: 298,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Fish and Chips',
    description:
      'Golden, shatteringly crisp beer-battered cod served alongside thick-cut chips, with a side of mushy peas and malt vinegar. The quintessential British seaside supper.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/fish-and-chips.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/fish-and-chips-prep.jpg', caption: 'Dipping fish in beer batter', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 20,
    cookTime: 30,
    totalTime: 50,
    difficulty: 'medium',
    spiceLevel: 0,

    cuisine: 'British',
    region: 'Europe',
    country: 'United Kingdom',

    categories: ['Dinner'],
    tags: ['high-protein', 'pescatarian', 'family-friendly', 'comfort-food'],
    ageGroups: ['kid', 'teen', 'adult'],

    nutrition: {
      calories: 680,
      protein: 34,
      carbs: 64,
      fat: 30,
      fiber: 5,
      sugar: 2,
      sodium: 920,
      iron: 2.4,
    },

    ingredients: [
      { qty: 1.5, unit: 'lb', item: 'cod fillets, cut into 4 portions, patted dry', group: 'Fish' },
      { qty: 1, unit: 'cup', item: 'all-purpose flour', group: 'Batter' },
      { qty: 0.5, unit: 'cup', item: 'cornstarch', group: 'Batter' },
      { qty: 1, unit: 'tsp', item: 'baking powder', group: 'Batter' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Batter' },
      { qty: 0.5, unit: 'tsp', item: 'black pepper', group: 'Batter' },
      { qty: 1, unit: 'cup', item: 'cold lager beer', group: 'Batter' },
      { qty: 2, unit: 'lb', item: 'russet potatoes, cut into thick chips (1/2-inch thick)', group: 'Chips' },
      { qty: 0, unit: '', item: 'vegetable oil, for deep frying (about 2 quarts)', group: 'Frying' },
      { qty: 0.5, unit: 'cup', item: 'all-purpose flour, for dredging', group: 'Fish' },
      { qty: 1, unit: '', item: 'lemon, cut into wedges', group: 'Serving' },
      { qty: 0, unit: '', item: 'malt vinegar, for serving', group: 'Serving' },
    ],
    steps: [
      { order: 1, instruction: 'Soak the cut chips in cold water for at least 30 minutes to remove excess starch. Drain and dry thoroughly with kitchen towels.', timerMinutes: 30 },
      { order: 2, instruction: 'Heat oil in a deep fryer or large heavy pot to 325 degrees F. Blanch the chips in batches for 5-6 minutes until cooked through but still pale. Remove to a wire rack. Increase the oil temperature to 375 degrees F.', timerMinutes: 6 },
      { order: 3, instruction: 'While the oil heats, make the batter: whisk together flour, cornstarch, baking powder, salt, and pepper. Pour in the cold beer and whisk until just combined. A few lumps are fine; do not overmix.', timerMinutes: null },
      { order: 4, instruction: 'Pat the fish fillets very dry. Dredge in the plain flour, shaking off excess, then dip into the beer batter, letting excess drip off.', timerMinutes: null },
      { order: 5, instruction: 'Carefully lower the battered fish into the 375 degree F oil. Fry for 6-8 minutes, turning once, until deep golden and the fish is cooked through. Fry in batches to avoid crowding. Drain on a wire rack and season immediately with salt.', timerMinutes: 8 },
      { order: 6, instruction: 'Return the blanched chips to the 375 degree F oil and fry for 3-4 minutes until golden and crispy. Drain on a wire rack and season generously with salt.', timerMinutes: 4 },
      { order: 7, instruction: 'Serve the fish and chips immediately on plates or wrapped in paper, with lemon wedges and malt vinegar on the side.', timerMinutes: null },
    ],
    notes: 'The double-fry technique for the chips is essential for a crispy exterior and fluffy interior. Use the coldest beer you can for the lightest, crispiest batter. Haddock is an excellent substitute for cod.',

    communityRating: 4.5,
    communityRatingCount: 330,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Sticky Toffee Pudding',
    description:
      'A gloriously moist date sponge cake drenched in a luscious, buttery toffee sauce and served warm. The crown jewel of British desserts and the ultimate cold-weather indulgence.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/sticky-toffee-pudding.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/sticky-toffee-pudding-prep.jpg', caption: 'Pouring toffee sauce over the cake', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 8,
    prepTime: 20,
    cookTime: 35,
    totalTime: 55,
    difficulty: 'medium',
    spiceLevel: 0,

    cuisine: 'British',
    region: 'Europe',
    country: 'United Kingdom',

    categories: ['Dessert'],
    tags: ['comfort-food', 'baking', 'make-ahead', 'holiday'],
    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 480,
      protein: 5,
      carbs: 68,
      fat: 22,
      fiber: 2,
      sugar: 50,
      sodium: 310,
      iron: 1.8,
    },

    ingredients: [
      { qty: 8, unit: 'oz', item: 'Medjool dates, pitted and chopped', group: 'Cake' },
      { qty: 1, unit: 'cup', item: 'boiling water', group: 'Cake' },
      { qty: 1, unit: 'tsp', item: 'baking soda', group: 'Cake' },
      { qty: 4, unit: 'tbsp', item: 'unsalted butter, softened', group: 'Cake' },
      { qty: 0.75, unit: 'cup', item: 'dark brown sugar, packed', group: 'Cake' },
      { qty: 2, unit: '', item: 'large eggs', group: 'Cake' },
      { qty: 1, unit: 'tsp', item: 'vanilla extract', group: 'Cake' },
      { qty: 1.5, unit: 'cups', item: 'all-purpose flour', group: 'Cake' },
      { qty: 1, unit: 'tsp', item: 'baking powder', group: 'Cake' },
      { qty: 0.25, unit: 'tsp', item: 'salt', group: 'Cake' },
      { qty: 6, unit: 'tbsp', item: 'unsalted butter', group: 'Toffee Sauce' },
      { qty: 1, unit: 'cup', item: 'dark brown sugar, packed', group: 'Toffee Sauce' },
      { qty: 1, unit: 'cup', item: 'heavy cream', group: 'Toffee Sauce' },
      { qty: 1, unit: 'tsp', item: 'vanilla extract', group: 'Toffee Sauce' },
      { qty: 1, unit: 'pinch', item: 'salt', group: 'Toffee Sauce' },
    ],
    steps: [
      { order: 1, instruction: 'Preheat oven to 350 degrees F. Butter and flour an 8-inch square baking pan. Place the chopped dates in a bowl, sprinkle with baking soda, and pour the boiling water over them. Stir and let sit for 10 minutes until soft and mushy.', timerMinutes: 10 },
      { order: 2, instruction: 'Cream the 4 tablespoons of softened butter and 3/4 cup brown sugar together with an electric mixer until light and fluffy, about 3 minutes. Beat in the eggs one at a time, then add vanilla.', timerMinutes: null },
      { order: 3, instruction: 'Whisk together flour, baking powder, and salt. Fold the dry ingredients into the butter mixture until just combined. Fold in the dates and their soaking liquid until evenly distributed.', timerMinutes: null },
      { order: 4, instruction: 'Pour the batter into the prepared pan and bake for 30-35 minutes until a toothpick inserted in the center comes out clean.', timerMinutes: 33 },
      { order: 5, instruction: 'While the cake bakes, make the toffee sauce: melt 6 tablespoons butter in a saucepan over medium heat. Add 1 cup brown sugar and stir until dissolved. Pour in the heavy cream and bring to a gentle boil. Simmer for 5 minutes until slightly thickened. Remove from heat and stir in vanilla and a pinch of salt.', timerMinutes: 5 },
      { order: 6, instruction: 'When the cake comes out of the oven, poke holes all over the top with a skewer. Pour half of the warm toffee sauce over the cake and let it soak in for 5 minutes.', timerMinutes: 5 },
      { order: 7, instruction: 'Cut into squares and serve warm, drizzled with the remaining toffee sauce. A scoop of vanilla ice cream or a dollop of clotted cream on the side is traditional.', timerMinutes: null },
    ],
    notes: 'The baking soda with the hot water softens the dates and helps them practically dissolve into the batter, creating the signature moist texture. The toffee sauce can be made ahead and reheated gently.',

    communityRating: 4.8,
    communityRatingCount: 267,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },

  // ============================================================
  // GERMAN (2)
  // ============================================================
  {
    title: 'Schnitzel',
    description:
      'A perfectly pounded, golden-fried pork cutlet with a light, crackly breadcrumb coating that puffs away from the meat. Served with a squeeze of lemon, this is German comfort food at its finest.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/schnitzel.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/schnitzel-prep.jpg', caption: 'Breading the pork cutlets', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 20,
    cookTime: 10,
    totalTime: 30,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'German',
    region: 'Europe',
    country: 'Germany',

    categories: ['Dinner', 'Family Meals'],
    tags: ['high-protein', 'under-30-min', 'family-friendly', 'weeknight-dinner'],
    ageGroups: ['kid', 'teen', 'adult'],
    audience: 'family',

    nutrition: {
      calories: 480,
      protein: 38,
      carbs: 28,
      fat: 22,
      fiber: 1,
      sugar: 1,
      sodium: 640,
      iron: 2.6,
    },

    ingredients: [
      { qty: 4, unit: '', item: 'boneless pork loin chops (about 5 oz each)', group: 'Schnitzel' },
      { qty: 1, unit: 'cup', item: 'all-purpose flour', group: 'Breading' },
      { qty: 3, unit: '', item: 'large eggs, beaten', group: 'Breading' },
      { qty: 2, unit: 'cups', item: 'fine dry breadcrumbs (not panko)', group: 'Breading' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Breading' },
      { qty: 0.5, unit: 'tsp', item: 'black pepper', group: 'Breading' },
      { qty: 0.5, unit: 'cup', item: 'vegetable oil or clarified butter, for frying', group: 'Frying' },
      { qty: 1, unit: '', item: 'lemon, cut into wedges', group: 'Serving' },
      { qty: 2, unit: 'tbsp', item: 'fresh parsley, chopped', group: 'Serving' },
    ],
    steps: [
      { order: 1, instruction: 'Place each pork chop between two sheets of plastic wrap. Using a meat mallet, pound to an even 1/4-inch thickness. This is thinner than you think. Season both sides with salt and pepper.', timerMinutes: null },
      { order: 2, instruction: 'Set up three shallow dishes: flour in the first, beaten eggs in the second, and breadcrumbs in the third. Dredge each cutlet in flour and shake off excess, then dip in egg, then press gently into breadcrumbs on both sides. Do not pack the crumbs tightly; a loose coating makes it puff during frying.', timerMinutes: null },
      { order: 3, instruction: 'Heat oil or clarified butter in a large skillet over medium-high heat until it reaches 350 degrees F (a breadcrumb dropped in should sizzle immediately). The oil should be about 1/4-inch deep.', timerMinutes: null },
      { order: 4, instruction: 'Fry the schnitzels one or two at a time, swirling the pan gently to keep the oil moving under the cutlet. Cook for 2-3 minutes per side until deep golden. The breadcrumb coating should puff slightly away from the meat.', timerMinutes: 5 },
      { order: 5, instruction: 'Drain briefly on a wire rack (not paper towels, which make the bottom soggy). Serve immediately with lemon wedges and fresh parsley. Traditional sides include German potato salad or a simple cucumber salad.', timerMinutes: null },
    ],
    notes: 'Clarified butter gives the most authentic flavor, but vegetable oil works well too. The key to a puffy, separated coating is not pressing the breadcrumbs on too firmly and having enough hot oil in the pan. Never cover a schnitzel after frying or it will lose its crunch.',

    communityRating: 4.5,
    communityRatingCount: 224,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Bratwurst with Sauerkraut',
    description:
      'Plump, juicy pork bratwursts seared until snapping-crisp, then nestled into a bed of tangy, slow-cooked sauerkraut with apples and caraway. A taste of a German beer garden.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/bratwurst-sauerkraut.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/bratwurst-sauerkraut-prep.jpg', caption: 'Browning the bratwursts', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 10,
    cookTime: 35,
    totalTime: 45,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'German',
    region: 'Europe',
    country: 'Germany',

    categories: ['Dinner'],
    tags: ['high-protein', 'gluten-free', 'dairy-free', 'one-pan', 'family-friendly', 'grilling', 'game-day'],
    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 520,
      protein: 22,
      carbs: 24,
      fat: 38,
      fiber: 5,
      sugar: 12,
      sodium: 1200,
      iron: 2.8,
    },

    ingredients: [
      { qty: 8, unit: '', item: 'fresh pork bratwursts', group: 'Bratwurst' },
      { qty: 1, unit: 'tbsp', item: 'vegetable oil', group: 'Bratwurst' },
      { qty: 2, unit: 'lb', item: 'sauerkraut, drained and rinsed', group: 'Sauerkraut' },
      { qty: 1, unit: '', item: 'large yellow onion, thinly sliced', group: 'Sauerkraut' },
      { qty: 1, unit: '', item: 'Granny Smith apple, peeled, cored, and sliced', group: 'Sauerkraut' },
      { qty: 1, unit: 'cup', item: 'German lager or pilsner', group: 'Sauerkraut' },
      { qty: 1, unit: 'tbsp', item: 'brown sugar', group: 'Sauerkraut' },
      { qty: 1, unit: 'tsp', item: 'caraway seeds', group: 'Sauerkraut' },
      { qty: 2, unit: '', item: 'bay leaves', group: 'Sauerkraut' },
      { qty: 4, unit: '', item: 'juniper berries, crushed (optional)', group: 'Sauerkraut' },
      { qty: 0.5, unit: 'tsp', item: 'black pepper', group: 'Sauerkraut' },
      { qty: 0, unit: '', item: 'whole grain mustard, for serving', group: 'Serving' },
    ],
    steps: [
      { order: 1, instruction: 'Heat oil in a large deep skillet or Dutch oven over medium-high heat. Sear the bratwursts on all sides until deep golden brown, about 6-8 minutes total. Remove and set aside.', timerMinutes: 8 },
      { order: 2, instruction: 'In the same pan, add the sliced onion and cook for 4 minutes until softened. Add the apple slices and caraway seeds, cooking for 2 more minutes.', timerMinutes: 6 },
      { order: 3, instruction: 'Add the drained sauerkraut, beer, brown sugar, bay leaves, juniper berries if using, and pepper. Stir to combine and bring to a simmer.', timerMinutes: null },
      { order: 4, instruction: 'Nestle the seared bratwursts into the sauerkraut mixture. Cover and simmer on low heat for 20-25 minutes until the bratwursts are cooked through (160 degrees F internal) and the sauerkraut is tender and flavorful.', timerMinutes: 22 },
      { order: 5, instruction: 'Remove bay leaves. Serve the bratwursts on a bed of the sauerkraut with whole grain mustard on the side and crusty bread or soft pretzels.', timerMinutes: null },
    ],
    notes: 'Do not poke the bratwursts with a fork while cooking or they will lose their juices. Rinsing the sauerkraut mellows its intensity; skip this step if you prefer a more assertive tang.',

    communityRating: 4.3,
    communityRatingCount: 176,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },

  // ============================================================
  // SCANDINAVIAN (2)
  // ============================================================
  {
    title: 'Swedish Meatballs',
    description:
      'Tender, lightly spiced pork and beef meatballs cloaked in a velvety cream sauce, served over buttered egg noodles with a tart lingonberry accompaniment. Pure Scandinavian comfort.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/swedish-meatballs.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/swedish-meatballs-prep.jpg', caption: 'Rolling the meatball mixture', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 6,
    prepTime: 25,
    cookTime: 30,
    totalTime: 55,
    difficulty: 'medium',
    spiceLevel: 0,

    cuisine: 'Scandinavian',
    region: 'Europe',
    country: 'Sweden',

    categories: ['Dinner', 'Family Meals'],
    tags: ['high-protein', 'comfort-food', 'family-friendly', 'freezer-friendly', 'batch-cooking'],
    ageGroups: ['kid', 'teen', 'adult'],
    audience: 'family',

    nutrition: {
      calories: 560,
      protein: 32,
      carbs: 34,
      fat: 32,
      fiber: 2,
      sugar: 4,
      sodium: 740,
      iron: 3.4,
    },

    ingredients: [
      { qty: 1, unit: 'lb', item: 'ground beef (80/20)', group: 'Meatballs' },
      { qty: 0.5, unit: 'lb', item: 'ground pork', group: 'Meatballs' },
      { qty: 0.5, unit: 'cup', item: 'breadcrumbs', group: 'Meatballs' },
      { qty: 0.25, unit: 'cup', item: 'whole milk', group: 'Meatballs' },
      { qty: 1, unit: '', item: 'large egg', group: 'Meatballs' },
      { qty: 1, unit: '', item: 'small yellow onion, finely grated', group: 'Meatballs' },
      { qty: 0.25, unit: 'tsp', item: 'ground allspice', group: 'Meatballs' },
      { qty: 0.25, unit: 'tsp', item: 'ground nutmeg', group: 'Meatballs' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Meatballs' },
      { qty: 0.5, unit: 'tsp', item: 'white pepper', group: 'Meatballs' },
      { qty: 2, unit: 'tbsp', item: 'unsalted butter', group: 'Cooking' },
      { qty: 1, unit: 'tbsp', item: 'olive oil', group: 'Cooking' },
      { qty: 3, unit: 'tbsp', item: 'unsalted butter', group: 'Cream Sauce' },
      { qty: 3, unit: 'tbsp', item: 'all-purpose flour', group: 'Cream Sauce' },
      { qty: 2, unit: 'cups', item: 'beef broth', group: 'Cream Sauce' },
      { qty: 1, unit: 'cup', item: 'heavy cream', group: 'Cream Sauce' },
      { qty: 1, unit: 'tbsp', item: 'soy sauce', group: 'Cream Sauce' },
      { qty: 1, unit: 'tsp', item: 'Dijon mustard', group: 'Cream Sauce' },
      { qty: 0.25, unit: 'cup', item: 'fresh dill or parsley, chopped', group: 'Garnish' },
      { qty: 0.5, unit: 'cup', item: 'lingonberry jam, for serving', group: 'Garnish' },
    ],
    steps: [
      { order: 1, instruction: 'Soak breadcrumbs in milk for 5 minutes. In a large bowl, combine the soaked breadcrumbs with ground beef, pork, egg, grated onion, allspice, nutmeg, salt, and white pepper. Mix gently until just combined. Do not overmix.', timerMinutes: 5 },
      { order: 2, instruction: 'With damp hands, roll the mixture into 1.5-inch meatballs (about 30 total). Place on a sheet pan.', timerMinutes: null },
      { order: 3, instruction: 'Heat 2 tablespoons butter and olive oil in a large skillet over medium heat. Brown the meatballs in batches, turning to get color on all sides, about 6 minutes per batch. They do not need to be cooked through. Transfer to a plate.', timerMinutes: 12 },
      { order: 4, instruction: 'In the same skillet, melt 3 tablespoons butter. Whisk in flour and cook for 2 minutes until golden. Gradually whisk in beef broth, then heavy cream, soy sauce, and Dijon mustard. Bring to a simmer, stirring until smooth and thickened, about 4 minutes.', timerMinutes: 6 },
      { order: 5, instruction: 'Return the meatballs to the sauce. Simmer gently, covered, for 12-15 minutes until the meatballs are cooked through (160 degrees F internal) and the sauce is rich and creamy.', timerMinutes: 14 },
      { order: 6, instruction: 'Garnish with fresh dill. Serve over buttered egg noodles or mashed potatoes with lingonberry jam on the side.', timerMinutes: null },
    ],
    notes: 'Grating the onion rather than dicing it gives the meatballs a smoother texture. The soy sauce is a Scandinavian trick that adds depth without a detectable soy flavor. Meatballs freeze beautifully before or after cooking.',

    communityRating: 4.7,
    communityRatingCount: 356,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
  {
    title: 'Norwegian Salmon with Dill',
    description:
      'A simple, elegant fillet of salmon roasted with butter, lemon, and fresh dill until just flaky and glistening. Proof that the finest Nordic cooking lets premium ingredients shine.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/norwegian-salmon-dill.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/norwegian-salmon-dill-prep.jpg', caption: 'Seasoning the salmon fillets', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 10,
    cookTime: 15,
    totalTime: 25,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'Scandinavian',
    region: 'Europe',
    country: 'Norway',

    categories: ['Dinner', 'Family Meals'],
    tags: ['high-protein', 'low-carb', 'gluten-free', 'pescatarian', 'under-30-min', 'weeknight-dinner', 'sheet-pan', 'keto'],
    ageGroups: ['kid', 'teen', 'adult'],
    audience: 'family',

    nutrition: {
      calories: 380,
      protein: 36,
      carbs: 2,
      fat: 25,
      fiber: 0,
      sugar: 1,
      sodium: 420,
      iron: 1.2,
    },

    ingredients: [
      { qty: 4, unit: '', item: 'salmon fillets, skin-on (6 oz each)', group: 'Salmon' },
      { qty: 2, unit: 'tbsp', item: 'unsalted butter, melted', group: 'Salmon' },
      { qty: 1, unit: 'tbsp', item: 'olive oil', group: 'Salmon' },
      { qty: 0.25, unit: 'cup', item: 'fresh dill fronds, roughly chopped, plus more for garnish', group: 'Salmon' },
      { qty: 1, unit: '', item: 'lemon, zested and juiced', group: 'Salmon' },
      { qty: 2, unit: '', item: 'cloves garlic, minced', group: 'Salmon' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Salmon' },
      { qty: 0.5, unit: 'tsp', item: 'black pepper', group: 'Salmon' },
      { qty: 0.5, unit: 'cup', item: 'sour cream or creme fraiche', group: 'Dill Sauce' },
      { qty: 2, unit: 'tbsp', item: 'fresh dill, minced', group: 'Dill Sauce' },
      { qty: 1, unit: 'tbsp', item: 'lemon juice', group: 'Dill Sauce' },
      { qty: 1, unit: 'pinch', item: 'salt', group: 'Dill Sauce' },
    ],
    steps: [
      { order: 1, instruction: 'Preheat oven to 425 degrees F. Line a sheet pan with parchment paper. Make the dill sauce by stirring together sour cream, minced dill, lemon juice, and a pinch of salt. Refrigerate until serving.', timerMinutes: null },
      { order: 2, instruction: 'Pat the salmon fillets very dry with paper towels. Place skin-side down on the prepared sheet pan.', timerMinutes: null },
      { order: 3, instruction: 'In a small bowl, mix the melted butter, olive oil, garlic, lemon zest, and lemon juice. Brush this mixture generously over the top and sides of each fillet.', timerMinutes: null },
      { order: 4, instruction: 'Season with salt and pepper, then press the chopped dill onto the top of each fillet.', timerMinutes: null },
      { order: 5, instruction: 'Roast for 12-15 minutes until the salmon is opaque on the edges but still slightly translucent in the very center (about 130 degrees F internal for medium). The fish will continue to cook as it rests.', timerMinutes: 14 },
      { order: 6, instruction: 'Let rest for 2 minutes, then serve with a dollop of the dill sauce, extra fresh dill, and lemon wedges. Boiled new potatoes and steamed green vegetables make ideal accompaniments.', timerMinutes: 2 },
    ],
    notes: 'Do not overcook the salmon. It should be slightly translucent in the very center when you take it out of the oven. Use the freshest salmon you can find; this recipe has nowhere for subpar fish to hide.',

    communityRating: 4.6,
    communityRatingCount: 192,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-01-15').toISOString(),
  },
];

export default europeanRecipes;
